(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eventgallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('macveth-photo-gallery')) return;
    customElements.define('macveth-photo-gallery', class extends HTMLElement {
      connectedCallback() {
        // Defer one microtask so the element's server-rendered children exist.
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.dialog = this.querySelector('[data-mvg-dialog]');
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
          this.photos = Array.from(this.querySelectorAll('[data-mvg-open]'));
          this.viewerImage = this.querySelector('[data-mvg-view-image]');
          this.viewerCaption = this.querySelector('[data-mvg-view-caption]');
          this.viewerCount = this.querySelector('[data-mvg-count]');
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };

          this.addEventListener('click', (event) => {
            const opener = event.target.closest('[data-mvg-open]');
            if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
              const index = this.photos.indexOf(opener);
              if (index < 0) return;
              this.opener = opener;
              this.showPhoto(index);
              try {
                this.dialog.showModal();
                event.preventDefault();
                this.previousOverflow = document.documentElement.style.overflow;
                document.documentElement.style.overflow = 'hidden';
                this.scrollLocked = true;
              } catch (_) {
                // The original full-size image URL remains a functional fallback.
              }
              return;
            }
            if (event.target.closest('[data-mvg-close]')) this.dialog.close();
            if (event.target.closest('[data-mvg-prev]')) this.showPhoto(this.index - 1);
            if (event.target.closest('[data-mvg-next]')) this.showPhoto(this.index + 1);
            if (event.target === this.dialog) this.dialog.close();
          }, options);

          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
            }
          }, options);
          this.dialog.addEventListener('close', () => {
            this.unlockScroll();
            this.viewerImage.removeAttribute('src');
            if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
          }, options);

          this.viewerImage.addEventListener('touchstart', (event) => {
            this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          }, { ...options, passive: true });
          this.viewerImage.addEventListener('touchend', (event) => {
            if (!this.touchStart || event.changedTouches.length !== 1) return;
            const dx = event.changedTouches[0].clientX - this.touchStart.x;
            const dy = event.changedTouches[0].clientY - this.touchStart.y;
            this.touchStart = null;
            if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.showPhoto(this.index + (dx < 0 ? 1 : -1));
          }, { ...options, passive: true });
          this.viewerImage.addEventListener('touchcancel', () => { this.touchStart = null; }, options);
        });
      }
      showPhoto(index) {
        if (!this.photos.length) return;
        this.index = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.index];
        this.viewerImage.src = photo.href;
        this.viewerImage.alt = photo.dataset.mvgAlt || '';
        this.viewerCaption.textContent = photo.dataset.mvgCaption || '';
        this.viewerCaption.hidden = !this.viewerCaption.textContent;
        this.viewerCount.textContent = (this.index + 1) + ' / ' + this.photos.length;
        for (const button of this.querySelectorAll('[data-mvg-prev], [data-mvg-next]')) {
          button.style.visibility = this.photos.length > 1 ? 'visible' : 'hidden';
        }
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.unlockScroll();
        if (this.controller) this.controller.abort();
        this.controller = null;
        this.touchStart = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["macveth-digital-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('macveth-full-hero')) {
    customElements.define('macveth-full-hero', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.cleanup) return;
        const video = this.querySelector('.mfh-video');
        const controls = this.querySelector('.mfh-playback');
        const button = this.querySelector('.mfh-video-toggle');
        if (!video || !controls || !button) return;
        const mobile = matchMedia('(max-width: 749px)');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        const listeners = [];
        const listen = (target, name, fn) => {
          if (!target || !target.addEventListener) return;
          target.addEventListener(name, fn);
          listeners.push(() => target.removeEventListener(name, fn));
        };
        let visible = false;
        let userPaused = false;
        let userStarted = false;
        let currentSource = '';
        let failedSource = '';
        let pendingPlay = false;
        let sourceVersion = 0;
        video.muted = true;
        video.defaultMuted = true;

        const eligible = () => !mobile.matches || this.dataset.mobileVideo === 'true';
        const allowed = () => userStarted || (this.dataset.autoplay === 'true' && !reducedMotion.matches && !connection?.saveData);
        const shouldPlay = () => eligible() && visible && !document.hidden && !userPaused && allowed();
        const sourceForViewport = () => {
          const template = (mobile.matches && this.querySelector('template[data-mfh-sources="mobile"]')) || this.querySelector('template[data-mfh-sources="desktop"]');
          if (!template) return '';
          const sources = Array.from(template.content.querySelectorAll('source[data-src]')).sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
          const targetWidth = Math.min((this.clientWidth || innerWidth) * Math.min(devicePixelRatio || 1, 2), mobile.matches ? 1280 : 1920);
          return (sources.find(source => Number(source.dataset.width) >= targetWidth) || sources[sources.length - 1])?.dataset.src || '';
        };
        const updateButton = () => {
          const playing = !video.paused && !video.ended;
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          button.setAttribute('aria-label', label);
          button.querySelector('[data-playback-label]').textContent = label;
          button.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
          button.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
        };
        const sync = () => {
          const next = sourceForViewport();
          const usable = eligible() && !!next && next !== failedSource;
          controls.hidden = !usable;
          if (!usable) {
            video.pause();
            this.dataset.videoReady = 'false';
            if (currentSource) {
              currentSource = '';
              sourceVersion += 1;
              pendingPlay = false;
              video.removeAttribute('src');
              video.load();
            }
            return;
          }
          if (currentSource && next !== currentSource) {
            video.pause();
            this.dataset.videoReady = 'false';
            currentSource = '';
            sourceVersion += 1;
            pendingPlay = false;
            video.removeAttribute('src');
            video.load();
          }
          if (!shouldPlay()) {
            video.pause();
            if (!allowed()) this.dataset.videoReady = 'false';
            updateButton();
            return;
          }
          if (!currentSource) {
            currentSource = next;
            video.src = next;
            video.load();
          }
          if (pendingPlay || !video.paused) return;
          pendingPlay = true;
          const attemptVersion = sourceVersion;
          const playAttempt = video.play();
          if (playAttempt && playAttempt.then) {
            playAttempt.then(() => {
              if (attemptVersion !== sourceVersion) return;
              pendingPlay = false;
              if (!shouldPlay()) video.pause();
              updateButton();
            }).catch(() => {
              if (attemptVersion !== sourceVersion) return;
              pendingPlay = false;
              updateButton();
            });
          } else {
            pendingPlay = false;
          }
        };

        listen(button, 'click', () => {
          if (!video.paused || pendingPlay) {
            userPaused = true;
            video.pause();
          } else {
            userPaused = false;
            userStarted = true;
            visible = true;
          }
          sync();
        });
        listen(video, 'playing', () => { this.dataset.videoReady = 'true'; updateButton(); });
        listen(video, 'pause', updateButton);
        listen(video, 'ended', () => { userPaused = true; updateButton(); });
        listen(video, 'error', () => { failedSource = currentSource; sync(); });
        listen(mobile, 'change', sync);
        listen(reducedMotion, 'change', () => { userStarted = false; sync(); });
        listen(connection, 'change', sync);
        listen(document, 'visibilitychange', sync);

        let observer;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(entries => {
            visible = entries.some(entry => entry.isIntersecting);
            sync();
          }, { threshold: 0 });
          observer.observe(this);
        } else {
          visible = true;
        }
        this.cleanup = () => {
          sourceVersion += 1;
          observer?.disconnect();
          listeners.forEach(remove => remove());
          video.pause();
          video.removeAttribute('src');
          video.load();
        };
        sync();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
